var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid is-col-min-15" }, [
    _c("div", { staticClass: "cell" }, [
      _c("div", [
        _c("article", { staticClass: "box" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Vehicle")]),
          _vm.vehicle && !_vm.vehicle.isActive
            ? _c("p", { staticClass: "subtitle has-text-danger" }, [
                _vm._v("This vehicle has been deleted"),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c(
              "table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                class: { "is-loading-no-header": _vm.isVehicleLoading },
              },
              [
                !_vm.isVehicleLoading && _vm.vehicle
                  ? _c("tbody", [
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Make"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.model.make))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Model"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.model.model))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Series"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.model.make))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Built"),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.pad(_vm.vehicle.buildMonth, 2)
                            ) +
                              _vm._s(_vm.vehicle.buildMonth ? "/" : "") +
                              _vm._s(_vm.vehicle.buildYear)
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Engine Size"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.engizeSize))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("VIN"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.vin))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Body Style"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.bodyId2))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Colour"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.colour))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Engine No."),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.engineNo))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Cylinders"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.cylinders))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Transmission"),
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.vehicle.transmissionType)),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Paint Group"),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.vehicle.paintGroup ===
                                _vm.paintGroupTypes.M3 &&
                                _vm.vehicle.paintGroupPlus
                                ? "M3+"
                                : _vm.vehicle.paintGroup
                            )
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("NRMA Schedule"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.scheduleId))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("NTAR Schedule"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.ntarScheduleId))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("MTA Schedule"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.mtaScheduleId))]),
                      ]),
                    ])
                  : _vm.isVehicleLoading
                  ? _c("tbody", [_vm._m(0)])
                  : _vm._e(),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("Odometer")]),
              _vm.readOnlyView
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: { value: _vm.innerValue.odometer },
                    }),
                  ])
                : _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0, precision: 0 },
                    model: {
                      value: _vm.innerValue.odometer,
                      callback: function ($$v) {
                        _vm.$set(_vm.innerValue, "odometer", _vm._n($$v))
                      },
                      expression: "innerValue.odometer",
                    },
                  }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "cell" }, [
      _c("div", [
        _c("article", { staticClass: "box" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Customer")]),
          _vm.customer && !_vm.customer.active
            ? _c("p", { staticClass: "subtitle has-text-danger" }, [
                _vm._v("This customer has been deleted"),
              ])
            : _vm._e(),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
              class: { "is-loading-no-header": _vm.isCustomerLoading },
            },
            [
              !_vm.isCustomerLoading && _vm.customer
                ? _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _c("span", [_vm._v("Name")]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: this.$v.vehicleCustomerGroup.$error,
                                expression:
                                  "this.$v.vehicleCustomerGroup.$error",
                              },
                            ],
                            staticClass:
                              "icon has-text-danger tooltip is-tooltip-danger is-tooltip-multiline",
                            attrs: {
                              "data-tooltip":
                                "Quote's customer does not match vehicle's customer. Click button next to name to fix.",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "mdi mdi-alert-circle mdi-18px",
                            }),
                          ]
                        ),
                      ]),
                      _c("td", [
                        _vm._v(" " + _vm._s(_vm.customer.fullname) + " "),
                        _vm.customer && !_vm.customer.active
                          ? _c(
                              "span",
                              { staticClass: "tag is-danger is-light" },
                              [_vm._v("Deleted")]
                            )
                          : _vm._e(),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: this.$v.vehicleCustomerGroup.$error,
                                expression:
                                  "this.$v.vehicleCustomerGroup.$error",
                              },
                            ],
                            staticClass:
                              "button is-small is-outlined is-danger is-pulled-right tooltip is-tooltip-topright",
                            attrs: {
                              "data-tooltip":
                                "Auto fix customer mismatch issue",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.fixCustomerMismatch()
                              },
                            },
                          },
                          [_vm._m(1)]
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Address"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.defaultAddress
                              ? _vm.defaultAddress.displayAddress
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Home"),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.homePhone ? _vm.homePhone.no : "")),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Work"),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.workPhone ? _vm.workPhone.no : "")),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Mobile"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.mobilePhone ? _vm.mobilePhone.no : "")
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Fax"),
                      ]),
                      _c("td", [_vm._v(_vm._s(_vm.fax ? _vm.fax.no : ""))]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Email"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.defaultEmail ? _vm.defaultEmail.address : ""
                          )
                        ),
                      ]),
                    ]),
                  ])
                : _vm.isCustomerLoading
                ? _c("tbody", [_vm._m(2)])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c(
                "span",
                {
                  staticStyle: { opacity: "0" },
                  attrs: { icon: "icon is-large" },
                },
                [_c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-30px" })]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-auto-fix mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c(
                "span",
                {
                  staticStyle: { opacity: "0" },
                  attrs: { icon: "icon is-large" },
                },
                [_c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-30px" })]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }